import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import duration from "dayjs/plugin/duration";
import isBetween from "dayjs/plugin/isBetween";
import isToday from "dayjs/plugin/isToday";
import localizedFormat from "dayjs/plugin/localizedFormat";
import minmax from "dayjs/plugin/minMax";
import relativeTime from "dayjs/plugin/relativeTime";
import timezone from "dayjs/plugin/timezone";
import toArray from "dayjs/plugin/toArray";
import utc from "dayjs/plugin/utc";

dayjs.extend(customParseFormat);
dayjs.extend(isBetween);
dayjs.extend(isToday);
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);
dayjs.extend(toArray);
dayjs.extend(utc);
dayjs.extend(minmax);
dayjs.extend(duration);
dayjs.extend(timezone);

export const STANDARD_DATE_FORMAT = "MM/DD/YYYY";
export const SIMPLE_DATE_FORMAT = "DD MMM, YYYY";

export const displayUSDateFormat = (dateString: string) => {
  if (!dateString) return null;
  return dayjs(dateString).format(STANDARD_DATE_FORMAT);
};

export const displayReadbleDate = (dateString: string) => {
  if (!dateString) return null;
  return dayjs(dateString).format(SIMPLE_DATE_FORMAT);
};

export default dayjs;
